
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up/personal-account",
      function () {
        return require("private-next-pages/sign-up/personal-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-up/personal-account"])
      });
    }
  